import { ROLES } from '@/constants/roles';

const defaultMeta = {
  layout: 'ui-design',
  title: 'Авторизация',
  hideMeta: true,
  accessList: [ROLES.guest],
};

export const loginPage = {
  path: '/login',
  name: 'login',
  component: () => import('./views/index.vue'),
  meta: defaultMeta,
  redirect: (to) => ({
    name: 'login-main',
  }),
  children: [
    {
      path: '/',
      name: 'login-main',
      component: () => import('./views/login.vue'),
      meta: {
        ...defaultMeta,
        title: 'Авторизоваться в системе',
      },
    },
    {
      path: 'credentials',
      name: 'login-credentials',
      component: () => import('./views/credentials.vue'),
      meta: {
        ...defaultMeta,
        title: 'Вход в систему с использованием логина',
      },
    },
    {
      path: 'register',
      name: 'register',
      component: () => import('./views/register.vue'),
      meta: {
        ...defaultMeta,
        title: 'Зарегистрироваться в системе',
      },
    },
    {
      path: 'signature',
      name: 'login-signature',
      component: () => import('./views/signature.vue'),
      meta: {
        ...defaultMeta,
        title: 'Войти с использованием УКЭП',
      },
    },
    // {
    //   path: 'create-organization',
    //   name: 'create-organization',
    //   component: () => import('./views/create-organization.vue'),
    //   meta: {
    //     ...defaultMeta,
    //     title: 'Создание организатора в системе',
    //   },
    //   props: (route) => ({
    //     token: route.query.token,
    //   }),
    //   beforeEnter: (to, from, next) => {
    //     if ([to?.query?.token].includes(undefined)) {
    //       next({ name: 'register' });
    //       return;
    //     }
    //     next();
    //   },
    // },
  ],
};

export default [
  loginPage,
];
